export function truncateText(text: string, maxChars: number): string {
  if (text.length <= maxChars) return text;
  const slice = text.slice(0, maxChars);
  const lastWhitespace = slice.search(/\s\S*$/);
  const cut = lastWhitespace > 0 ? slice.slice(0, lastWhitespace) : slice;
  return cut.trimEnd() + "…";
}
